import React from 'react'
import { CustomCellRendererProps } from 'ag-grid-react'
import { FontWeight } from 'view/styles/constants'
import styled from '@emotion/styled'
import { isFirstCollateralRow } from './utils'

const Text = styled.span<{ fontWeight?: FontWeight }>`
  font-weight: ${props => props.fontWeight ?? FontWeight.Normal};
  padding-left: 10px;
`

export const TextOncePerCollateral = (
  props: CustomCellRendererProps & {
    fontWeight?: FontWeight
  }
) => {
  if (!isFirstCollateralRow(props)) return null

  return <Text fontWeight={props.fontWeight}>{props.valueFormatted ?? props.value}</Text>
}
